<template>
  <div class="onboarding-page-container">

    <div :class="firstLogin ? '' : 'mt-12'" class="onboarding-page">

      <div class="semanticsection-title2 primary--text">Herzlich Willkommen im neuen Maklerportal der DMB Rechtsschutz!
      </div>

      <div class="subtitle">{{ versandoptionen ?
        "Möchten Sie Ihre Versandoptionen aktualisieren?" :
        "Jetzt noch schneller, einfacher, übersichtlicher und ganz speziell an die Anforderungen von Maklern angepasst. Hier die Vorteile für Sie:" }}
      </div>

      <template v-if="!versandoptionen">

        <onboarding-content :page="allPages[currentPage-1]" />

        <span class="page-number">{{ currentPage }} von {{ allPages.length }}</span>

        <v-container class="pa-0" fluid>
          <v-row no-gutters
                 class="stepperbuttons">
            <v-btn v-if="currentPage > 1"
                   color="primary"
                   class="standard-button"
                   @click="stepBack">Zurück
            </v-btn>
            <v-spacer />
            <div>
              <v-btn color="primary"
                     class="standard-button"
                     @click="stepForward">{{ currentPage === allPages.length ? "Los geht's" : "Weiter" }}
              </v-btn>
              <span v-if="currentPage < allPages.length" class="skip secondary--text"
                    @click="skip">Überspringen
              </span>
            </div>
          </v-row>
        </v-container>

      </template>

      <template v-else>
        <v-container class="pa-0" fluid>
          <v-row no-gutters
                 class="versandbuttons">
            <router-link :to="{name: 'BenutzerProfil', params: { editversand: true } }">
              <v-btn color="primary"
                     class="standard-button">Ja
              </v-btn>
            </router-link>
            <router-link :to="'/start'">
              <v-btn color="primary"
                     class="standard-button">Nein
              </v-btn>
            </router-link>
          </v-row>
        </v-container>
      </template>

    </div>

  </div>
</template>
<script>
import OnboardingContent from '@/components/userProfile/OnboardingContent';
import {ONBOARDING_PAGES} from '@/components/userProfile/valueLists';
//import {RIGHTS} from "@/store/user";

export default {
  name: "OnboardingPage",
  components: { OnboardingContent },
  data() {
    return {
      currentPage: 1,
      allPages: ONBOARDING_PAGES,
      versandoptionen: false
    };
  },
  computed: {
    firstLogin() {
      return this.$store.getters.firstLogin;
    },
    hideVersandoptionen () {
      return true; //!this.$store.getters.checkAuthorization(RIGHTS.PROFIL);
    }
  },
  methods: {
    stepBack() {
      this.currentPage--;
    },
    stepForward() {
      this.currentPage < this.allPages.length ? this.currentPage++ :
        this.hideVersandoptionen ?
          this.$router.push('/start') :
          this.versandoptionen = true;
    },
    skip() {
      this.hideVersandoptionen ? this.$router.push('/start') : this.versandoptionen = true;
    }
  }
};
</script>
<style>
.onboarding-page-container {
  margin: 0 48px 100px 48px;
  display: flex;
  justify-content: center;
}

.onboarding-page {
  max-width: 768px;
  width: 768px;
  font-size: 16px !important;
}

.onboarding-page .semanticsection-title2 {
  margin: 0 0 16px 0 !important;
}

.onboarding-page .subtitle {
  margin-bottom: 56px;
}

.onboarding-page .page-number {
  margin: 16px auto 0 auto;
  display: block;
  text-align: center;
  font-size: 14px;
}

.onboarding-page .stepperbuttons {
  margin: 56px auto 0 auto !important;
  width: 100%;
  max-width: 448px;
}

.onboarding-page .stepperbuttons > div {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.onboarding-page .skip {
  text-align: center;
  font-size: 13px;
  margin-top: 8px;
  cursor: pointer;
}

.onboarding-page .versandbuttons .v-btn {
  margin: -16px 24px 0 0;
}

.onboarding-page .standard-button:focus::before {
  opacity: 0!important;
}
</style>
